export default __webpack_public_path__ + "static/buyers-edge-120x76-1b72d868f28cff0004756ca62f120718.webp";